export const filterNumericInput = (value: string) => {
    return value.replace(/[^0-9]/g, '');
  };
  